import React, { useContext, useMemo } from 'react';

import Divider from '../../../../../../../../common/elements/Divider/Divider';
import Button from '../../../../../../../../common/general/Button';
import Icon from '../../../../../../../../common/general/Icon';
import { FileViewerContext } from '../../../../../../../../contexts/FileViewerContext';
import { TRAVEL_TOPIC } from '../../taskConstants';

import {
  FileViewer,
  TaskButtonProps,
  TaskComponent,
  TaskDetailsAttachmentsProps,
  TaskDividerProps,
  TaskIconProps
} from './taskAttachmentTypes';
import useTaskDetailsAttachmentsActions from './useTaskDetailsAttachmentsActions';

import './TaskDetailsAttachments.scss';

const TaskButton = Button as TaskComponent<TaskButtonProps>;

const TaskDivider = Divider as TaskComponent<TaskDividerProps>;

const TaskIcon = Icon as TaskComponent<TaskIconProps>;

export default function TaskDetailsAttachments({
  taskForm,
  taskId,
  ssuId,
  onAttachmentSaved
}: TaskDetailsAttachmentsProps): React.ReactElement | null {
  const fileViewer = useContext(FileViewerContext) as FileViewer;
  const isTravelTask = taskForm?.topicType === TRAVEL_TOPIC;
  const canAddAttachment = Boolean(taskId && ssuId);
  const attachments = useMemo(() => taskForm?.attachments || [], [taskForm?.attachments]);
  const { openAddAttachmentModal, openAttachmentPreview, confirmRemoveAttachment } = useTaskDetailsAttachmentsActions({
    taskId,
    ssuId,
    onAttachmentSaved,
    fileViewer
  });

  if (!isTravelTask) return null;

  return (
    <>
      <div className="etc-body-details">
        <div className="etc-body-details-block">
          <div className="etc-body-details-block-label etc-body-details-comments-label">
            Attachments
            <TaskButton priority="medium" size="h28" disabled={!canAddAttachment} onClick={openAddAttachmentModal}>
              <TaskIcon>add</TaskIcon> Add
            </TaskButton>
          </div>
          {attachments.length > 0 && (
            <div className="etc-body-details-block-value">
              {attachments.map(attachment => (
                <div key={attachment.fileId} className="etc-body-details-attachment-row">
                  <button
                    className="etc-body-details-attachment-link"
                    type="button"
                    onClick={() => openAttachmentPreview(attachment)}
                  >
                    <span>{attachment.fileName}</span>
                  </button>
                  <button
                    className="etc-body-details-attachment-remove"
                    type="button"
                    aria-label={`Remove ${attachment.fileName}`}
                    onClick={() => confirmRemoveAttachment(attachment)}
                  >
                    <TaskIcon>close</TaskIcon>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      <TaskDivider />
    </>
  );
}
